<template>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back" @click="goBack">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="main_wrapper ion-padding ">
    <h1 class="mt-3">Locumate Billing System</h1>

    <div v-if="paymentIntentCheck">
      <div v-if="paymentIntent.unpaidInvoices">
        <h3>Unpaid invoices</h3>
        <template v-for="item in paymentIntent.unpaidInvoices" :key="item.id">
          <div class="intent-wrapper">
            <div class="intent-title"><b>Invoice# {{ item.id }} </b></div>
            <div class="form_text ">
              <div class="text "> {{ item.description }}</div>
            </div>
          </div>
        </template>
      </div>
      <div v-if="paymentIntent.paymentIntent.invoices.length">
        <h3 class="mt-3">Payment Intent</h3>
        <template v-for="item in paymentIntent.paymentIntent.invoices" :key="item.id">
          <div class="intent-wrapper">
            <div class="intent-title"><b>Invoice# {{ item.id }} </b></div>
            <div class="form_text ">
              <div class="text "> {{ item.description }}</div>
            </div>
          </div>
        </template>
      </div>
      <div class="intent-wrapper">
        <div class="intent-title"><b>Total Payment: </b></div>
        <div class="form_text ">
          <div class="text "> {{ Sum() }}</div>
        </div>
      </div>
      <el-form
          :model="formsData.userForm"
          :rules="formsData.userForm.rules"
          :ref="(el) => (formsData.userForm.ref = el)"
          :label-position="'top'"
      >
        <el-form-item class="mt-3" label="Choose a payment method">
          <el-select
              @change="checkPayChange()"
              style="width: 100%;"
              v-model="formsData.userForm.checkPay.value"
              placeholder="Select"
          >
            <el-option
                v-for="item in checkPayOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="border" v-if="formsData.userForm.checkPay.value == 1">
        <div>
          <div>
            <label>Credit Card</label>
            <div class="mt20" id="stripe-element-mount-point"/>
            <div class="mt20" id="card-errors" role="alert"></div>
          </div>
        </div>

        <div class="div mt-3">
          <button
              @click="cardPay"
              class="el-button el-button--blue"
              id="submit"
          >
            Submit Payment
          </button>
        </div>
      </div>

      <div class="border" v-if="formsData.userForm.checkPay.value == 2">
        <div>
          <label>Bank Payment</label>
          <div class="mt20" id="au-bank-account-element"/>
          <div class="mt20" id="bank-errors" role="alert"></div>
        </div>
        <div class="div mt-3">
          <button
              @click="bankPay"
              class="el-button el-button--blue"
              id="bank-submit"
          >
            Submit Payment
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <h5>There are no outstanding invoices on your account.</h5>
    </div>
    <div class="page_title mt-3">System Information:</div>
    <div class="form_text ">
      <div class="text ">
        Locumate integrates with
        <a target="_blank" href="https://www.stripe.com">Stripe</a> to deliver a
        seamless payment process for Pharmacies. Stripe will be used to collect
        payments and distribute directly to Locums. You will receive a statement summary which collates all invoices in
        one easy transaction, along with
        individual invoices for your records.
      </div>
    </div>
    <div class="page_title mt-3">Security and Privacy Information:</div>
    <div class="form_text">
      <div class="text ">
        Stripe has been audited by a PCI-certified auditor and is certified to
        <a
            target="_blank"
            href="https://www.visa.com/splisting/searchGrsp.do?companyNameCriteria=stripe"
        >PCI Service Provider Level 1</a
        >.
        <br/>
        This is the most stringent level of certification available in the
        payments industry. Stripes Privacy Policy can be accessed at:
        <a target="_blank" href="https://stripe.com/au/privacy"
        >https://stripe.com/au/privacy</a
        >
      </div>
    </div>
  </div>
</template>
<style scoped>
#card-errors {
  color: red;
}

.mt20 {
  margin-top: 20px;
}

#bank-errors {
  color: red;
}

.border {
  border: 1px solid gray;
  padding: 12px 8px;
  box-shadow: 0px 11px 32px rgb(62 80 80 / 0.3);
}
</style>

<script>
import {ElMessage} from "@/components/Vendor/Element";
import {onMounted, computed, ref} from "vue";
import {addIcons} from "ionicons";
import {arrowBackOutline} from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});
import {IonToolbar, IonButton, IonButtons, IonIcon} from "@ionic/vue";
import {useRouter} from "vue-router";
import {loadStripe} from "@stripe/stripe-js";
import {useStore} from "vuex";
import formHooks from "@/hooks/form/form";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
  },

  setup() {
    const $router = useRouter();

    let paymentIntentCheck = ref(false);
    const style = {
      base: {
        fontWeight: '500',
        backgroundColor: '#f1f1f1',
        iconColor: '#2463FFFF',
        color: '#2463ff',
        fontSize: '18px',
        fontFamily: 'inherit',

        ':-webkit-autofill': {
          color: '#000',
        },
        '::placeholder': {
          color: 'rgba(76,74,74,0.5)',
        },
      },
      invalid: {
        iconColor: '#e70404',
        color: '#e70404',
      },
    };


    let stripe = null;
    let elements = null;
    const $store = useStore();


    const paymentIntent = computed(() => {
      return $store.getters.paymentIntent;
    });

    paymentIntentCheck = computed(() => {
      return $store.getters.paymentIntentCheck;
    });


    const PUBLIC_KEY = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

    onMounted(async () => {
      setFormRefs();
    });

    async function cardPay() {
      const cardElement = elements.getElement("card");
      const clientSecret = $store.getters.paymentIntent.clientSecret;
      const userName = $store.getters.paymentIntent.user.name

      try {
        const responce = await stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: userName,
            },
          },
        });

        var displayError = document.getElementById("card-errors");
        if (responce.error) {
          displayError.textContent = responce.error.message;
        } else {
          ElMessage({
            type: "success",
            message: "Thank You! Your payment in progress",
          });
          $router.push({
            name: "profile",
          });
        }
      } catch (error) {
        console.log(error.message);
      }
    }

    async function bankPay() {
      const auBankAccount = elements.getElement("auBankAccount");
      const clientSecret = $store.getters.paymentIntent.clientSecret;
      const userName = $store.getters.paymentIntent.user.name
      const userEmail  = $store.getters.paymentIntent.user.email
      try {
        const responce = await stripe.confirmAuBecsDebitPayment(clientSecret, {
          payment_method: {
            au_becs_debit: auBankAccount,
            billing_details: {
              name: userName,
              email: userEmail,
            },
          },
        });

        var displayError = document.getElementById("card-errors");
        if (responce.error) {
          displayError.textContent = responce.error.message;
        } else {
          ElMessage({
            type: "success",
            message: "Thank You! Your payment in progress",
          });
          $router.push({
            name: "profile",
          });
        }
      } catch (error) {
        console.log(error.message);
      }
    }

    const goBack = () => {
      $router.push({
        name: "profile",
      });
    };

    const checkPayChange = async () => {
      const appearance = {
        theme: 'night',
        hidePostalCode: true,
        style: style,
      };
      if (formsData.userForm.checkPay.value == 2) {
        stripe = await loadStripe(
            PUBLIC_KEY
        );
        elements = await stripe.elements();
        const auBankAccount = elements.create("auBankAccount", appearance);
        await auBankAccount.mount("#au-bank-account-element");
        const bank = await elements.getElement("auBankAccount");
        bank.addEventListener("change", function (event) {
          const displayError = document.getElementById("bank-errors");
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = "";
          }
        });
      } else if (formsData.userForm.checkPay.value == 1) {
        stripe = await loadStripe(
            PUBLIC_KEY
        );

        elements = await stripe.elements();
        const element = elements.create("card", appearance);
        await element.mount("#stripe-element-mount-point");
        const card = await elements.getElement("card");
        card.addEventListener("change", function (event) {
          const displayError = document.getElementById("card-errors");
          if (event.error) {
            displayError.textContent = event.error.message;
          } else {
            displayError.textContent = "";
          }
        });
      }
    };

    const formsDataArray = {
      userForm: {
        checkPay: {value: 0, ref: null},
      },
    };

    const checkPayOption = [
      {label: "Choose a payment method", value: 0},
      {label: "Pay via Credit Card", value: 1},
      {label: "Pay via Bank Transfer", value: 2},
    ];
    const Sum = () => {
      const invoicesArray = [];

      function add(accumulator, a) {
        return accumulator + a;
      }

      let sumInvoicesArray = 0
      if (Array.isArray(paymentIntent.value.paymentIntent.invoices)) {
        paymentIntent.value.paymentIntent.invoices.map(item => {
          invoicesArray.push(item.amount)
        })
      }
      if (invoicesArray.length) {
        sumInvoicesArray = invoicesArray.reduce(add);
      }
      const unpaidInvoicesArray = [];
      if (Array.isArray(paymentIntent.value.unpaidInvoices)) {
        paymentIntent.value?.unpaidInvoices.map(item => {
          unpaidInvoicesArray.push(item.amount)
        })
      }
      let sumUnpaidInvoicesArray = 0
      if (unpaidInvoicesArray.length) {
        sumUnpaidInvoicesArray = unpaidInvoicesArray.reduce(add)
      }
      const totalSum = sumInvoicesArray + sumUnpaidInvoicesArray;
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(totalSum);
    }

    const amount = (number) => {
      return new Intl.NumberFormat("en-AU", {
        style: "currency",
        currency: "AUD",
      }).format(number / 100);
    };
    const {setFormRefs, formsData} = formHooks(formsDataArray);
    return {
      formsData,
      goBack,
      cardPay,
      bankPay,
      paymentIntentCheck,
      checkPayOption,
      checkPayChange,
      paymentIntent,
      Sum,
      amount,
    };
  },
};
</script>
